export default __webpack_public_path__ + "static/media/manage.ba4e3953.svg";